import '@/scss/main.scss';

import { createApp } from 'vue';
import { createPinia } from 'pinia';
import yandexMetrika from '../plugins/yandexMetrika';
import * as Sentry from '@sentry/vue';
import App from './App.vue';
import router from './router';
import { setErrorHandler } from '@beautybox/ui-kit/utils/errorHandler';
import { toastPlugin } from '@beautybox/ui-kit/plugins/toasts';
import { requestV3 } from '@beautybox/core/plugins/request';
import { config } from '@/config';

const pinia = createPinia();

const app = createApp(App);

Sentry.init({
    app,
    dsn: 'https://7a60d1d2499bd8c66a058e256b23ce5d@sentry.beautybox-stage.ru/4',
    tracePropagationTargets: [
        'localhost',
        /^https:\/\/beautybox-stage.ru\//,
        /^https:\/\/beautybox.ru\//,
    ],
    integrations: [
        new Sentry.BrowserTracing({
            routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        }),
        new Sentry.Replay(),
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    environment: import.meta.env.VITE_SENTRY_ENV,
});

app.use(pinia);
app.use(router);
app.use(requestV3, config);
app.use(toastPlugin);
app.use(yandexMetrika, {
    id: import.meta.env.VITE_YANDEX_METRIKA_ID,
    env: import.meta.env.MODE,
});

app.mount('#app');

setErrorHandler();
